exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.certain[data-v-5bad925a]{background:#f13a3a\n}", ""]);

// exports
